import { connect, MapStateToProps } from "react-redux";

import { getPrimaryText, getSecondaryText } from "@multiweb/reactCore/i18n";
import { IAppState } from "@multiweb/types/react";
import { LocalizationProviderComponent, LocalizationProviderComponentChildrenProps } from "./LocalizationProviderComponent";

export type LocalizationProviderProps = {
    /** Lokalizační klíč pro získání překladů */
    readonly locKey: string;
    /** Výchozí hodnota pro primární text, která se použije, pokud není klíč načtený. Výchozí hodnota je nastavena na "". */
    readonly defaultText?: string;
    /** Výchozí hodnota pro sekundární text (popisek), která se použije, pokud není klíč načtený. Výchozí hodnota je nastavena na "". */
    readonly defaultTitle?: string;
    /** Parametry pro dosazení do překladu primárního textu daného klíče, pokud je parametrizovaný. */
    readonly textParams?: string[];
    /** Parametry pro dosazení do překladu sekundárního textu (popisku) daného klíče, pokud je parametrizovaný. */
    readonly titleParams?: string[];
};

type StateProps = LocalizationProviderComponentChildrenProps;

const mapStateToProps: MapStateToProps<StateProps, LocalizationProviderProps, IAppState> = (state, {
    locKey,
    defaultText = "",
    defaultTitle = "",
    textParams,
    titleParams,
}) => ({
    text: getPrimaryText(state, locKey, textParams) ?? defaultText,
    title: getSecondaryText(state, locKey, titleParams) ?? defaultTitle,
});

export const LocalizationProvider = connect(mapStateToProps)(LocalizationProviderComponent);
